import styled, { keyframes } from "styled-components";
const blink = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.1;
    }
    100% {
        opacity: 1;
    }
`;
export const NoticeContainer = styled.div`
  margin-top: 16px;
  font-size: 13px;
  margin-bottom: -8px;
  color: indigo;
`;
export const UploaderContainer = styled.section`
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
  margin-bottom: 20px;
  overflow: hidden;
  padding: 16px 8px;
  weight: 100%;
  .title-area {
    font-size: 22px;
    font-weight: bold;
    .description {
      font-size: 14px;
      font-weight: normal;
      background: moccasin;
      padding: 20px;
      border-radius: 8px;
    }
  }
  .items {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
    .uploading {
      cursor: progress !important;
      animation: ${blink} 2s ease-in infinite;
      label {
        cursor: progress !important;
      }
      input {
        cursor: progress !important;
      }
    }
    .item {
      width: 23%;
      margin-top: 16px;
      border: dashed 2px #ccc;
      border-radius: 8px;
      padding: 8px;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      overflow: hidden;
      label {
        width: 100%;
        cursor: pointer;
        text-align: center;
        color: #ccc;
        svg {
          margin-top: 64px;
          font-size: 96px;
        }
        .floated {
          position: absolute;
          right: calc(50% - 48px);
        }
        .img {
          img {
            width: 100%;
            aspect-ratio: 3/4;
            object-fit: cover;
          }
        }
        input {
          width: 100%;
          height: 100%;
          display: none;
        }
      }
      .disabled {
        cursor: default;
      }
      .title {
        margin-top: 16px;
        text-align: center;
        font-size: 14px;
      }
      .status {
        position: absolute;
        top: 0;
        left: 0;
        padding: 4px 8px;
        font-size: 13px;
        background: #fff;
        border-bottom-right-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
      }
      .pending {
        color: orange;
      }
      .approve {
        color: green;
      }
      .reject {
        color: red;
      }
      @media only screen and (max-width: 760px) {
        width: 48%;
      }
    }
  }
`;
